/* eslint-disable react/prop-types */
import React from "react"
import * as styles from "./JobTransformationCard.module.css" // Import the CSS file
import Heading from "../text/heading/heading"
import BodyText from "../text/body-text/body-text"

const JobTransformationCard = ({
  imageSrc,
  name,
  company,
  jobTitle,
  before,
  after,
}) => {
  return (
    <div className={styles.cardTest}>
      {/* Content inside the card */}
      <div className={styles.userImage}>{imageSrc}</div>

      <div className={"flex flex-col items-center"}>
        <Heading variant="h5" className={"text-center"}>
          {name}
        </Heading>
        <BodyText variant="bodyText7" className={"text-center"}>
          {company}
        </BodyText>
        <BodyText
          variant="bodyText7"
          className={`${"text-center text-[#4559ED] mt-1 "} ${
            !jobTitle ? `${styles.emptyJob}` : ""
          }`}
        >
          {!jobTitle ? "assisstant " : jobTitle}
        </BodyText>{" "}
      </div>

      <div className={"flex gap-2 w-full px-2"}>
        <div className="max-w-[35%] flex flex-col gap-2">
          <div
            className={`h-[26px] flex items-center justify-center px-2 rounded-md bg-[#F8C807]`}
          >
            <BodyText variant="bodyText7">Before</BodyText>
          </div>
          <BodyText variant="bodyText7" className={"text-center font-bold"}>
            {before}
          </BodyText>
        </div>
        <div
          className="h-[5px] flex-1 mt-[10px]"
          style={{
            background: "linear-gradient(to right, #F8C807 90%, #FFF7D8 10%)",
          }}
        ></div>
        <div className="max-w-[35%] flex flex-col gap-2">
          <div
            className={`h-[26px] flex items-center justify-center px-2 rounded-md bg-[#FFEED5] border border-[#F8C807]`}
          >
            <BodyText variant="bodyText7">After</BodyText>
          </div>
          <BodyText variant="bodyText7" className={"text-center font-bold"}>
            {after}
          </BodyText>
        </div>
      </div>
    </div>
  )
}

export default JobTransformationCard
